import { ca } from '@cian/analytics';

export const trackButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardCountryBuilder',
    action: 'Click',
    label: 'reliable_company',
    useLastProducts: true,
  });
};
